import { render, staticRenderFns } from "./StaticImage.vue?vue&type=template&id=07a39ac6&"
import script from "./StaticImage.vue?vue&type=script&lang=ts&"
export * from "./StaticImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports